import {ModalPromocode} from './ModalPromocode'
export default ModalPromocode